import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function cepValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const cep = control.value.substring(0, 9);

    if (!cep) {
      return null;
    }

    const isValid = /^\d{5}-\d{3}$/.test(cep);
    return isValid ? null : { cepInvalid: true };
  };
}
